import { AttendanceService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useSchedulesHolidayRequestsNotApprovedCountQueryKey = 'GetSchedulesHolidayRequestsNotApprovedCount';
export const useSchedulesHolidayRequestsNotApprovedCount = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof AttendanceService.getSchedulesHolidayRequestsNotApprovedCount>>,
      QueryError,
      Awaited<ReturnType<typeof AttendanceService.getSchedulesHolidayRequestsNotApprovedCount>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useSchedulesHolidayRequestsNotApprovedCountQueryKey, ...(queryKey ?? [])],
    () => AttendanceService.getSchedulesHolidayRequestsNotApprovedCount(),
    options
  );
